import type { BrandThemeIcon } from '@jotta/types/Brand'

import type { BoxPropsAs } from '../../Elements/Box/Box'
import { SvgBox } from '../../Elements/Box/Box'

export interface BrandIconProps {
  icon: BrandThemeIcon
  className?: string
}

export const BrandIcon = ({
  icon,
  ...props
}: BoxPropsAs<'svg', BrandIconProps>) => (
  <SvgBox as={icon} width="1em" height="1em" {...props} />
)

export function PlainBrandIcon({
  icon,
  noSize = false,
  width,
  height,
  ...props
}: {
  icon: BrandThemeIcon
  noSize?: boolean
  width?: string | number
  height?: string | number
  className?: string
}) {
  const Icon = icon
  const hasSize = width !== undefined || height !== undefined
  width = hasSize ? width : '100%'
  height = hasSize ? height : '100%'
  return <Icon width={width} height={height} {...props} />
}
